// First Created - 26 Aug 2026
// Author - Atul Pandey
// Purpose - RTK Query API slice for Google Docs OAuth integration
// Updated - 31 Aug 2026 - added disconnect endpoint

import {
  apiSlice,
} from '@/app/api/apiSlice'

export const googleDocsAuthApiSlice =
  apiSlice.injectEndpoints({

    endpoints:
      builder => ({

        /*
        |--------------------------------------------------------------------------
        | Google Docs Connection Status
        |--------------------------------------------------------------------------
        */

        getGoogleDocsConnectionStatus:
          builder.query({

            query:
              () => ({
                url:
                  '/googleDocsAuth/status',

                method:
                  'GET',
              }),

              // 31 Aug 2026
              providesTags: [
                'GoogleDocsConnection',
              ],


          }),

          /*
        |--------------------------------------------------------------------------
        | Disconnect Google Docs - 31 Aug 2026
        |--------------------------------------------------------------------------
        */

        disconnectGoogleDocs:
        builder.mutation({

            query:
            () => ({

                url:
                '/googleDocsAuth/disconnect',

                method:
                'PATCH',

            }),

            invalidatesTags: [
            'GoogleDocsConnection',
            ],

        }),

        testGoogleReflectionFolder: 
          builder.query({
                query: () => ({
                    url:
                    '/googleDriveTest/reflectionsFolder',

                    validateStatus: (
                    response,
                    result
                    ) => {
                    return (
                        response.status === 200 &&
                        !result.isError
                    )
                    },
                }),
          }),

          testGoogleReflectionDocument: 
            builder.query({
                query: ({
                    reflectionDate,
                } = {}) => ({

                    url:
                    '/googleDriveTest/reflectionDocument',

                    params:
                    reflectionDate
                        ? {
                            reflectionDate,
                        }
                        : undefined,

                    validateStatus: (
                    response,
                    result
                    ) => {
                    return (
                        response.status === 200 &&
                        !result.isError
                    )
                    },

                }),
            }),
          testGoogleReflectionTab: 
            builder.query({
                query: ({
                    reflectionDate,
                } = {}) => ({

                    url:
                    '/googleDriveTest/reflectionTab',

                    params:
                    reflectionDate
                        ? {
                            reflectionDate,
                        }
                        : undefined,

                    validateStatus: (
                    response,
                    result
                    ) => {
                    return (
                        response.status === 200 &&
                        !result.isError
                    )
                    },

                }),
            }),
            // 27 Aug 2026
            testGoogleReflectionPublish: 
                builder.mutation({
                    query: payload => ({

                        url:
                        '/googleDriveTest/reflectionPublish',

                        method:
                        'POST',

                        body:
                        payload,

                    }),
            }),

            testGoogleReflectionHtmlParse: 
                builder.mutation({
                    query: ({
                        reflectionHtml,
                    }) => ({

                        url:
                        '/googleDriveTest/reflectionHtmlParse',

                        method:
                        'POST',

                        body: {
                        reflectionHtml,
                        },

                    }),
            }),

            testGoogleReflectionFormattingModel: 
                builder.mutation({
                    query: ({
                        reflectionHtml,
                    }) => ({

                        url:
                        '/googleDriveTest/reflectionFormattingModel',

                        method:
                        'POST',

                        body: {
                        reflectionHtml,
                        },

                    }),
            }),

            testGoogleReflectionFormattingRequests: 
                builder.mutation({
                    query: ({
                        reflectionHtml,
                        insertionStartIndex,
                        tabId,
                    }) => ({

                        url:
                        '/googleDriveTest/reflectionFormattingRequests',

                        method:
                        'POST',

                        body: {
                        reflectionHtml,
                        insertionStartIndex,
                        tabId,
                        },

                    }),
            }),

            testGoogleReflectionFormattedPublish: 
                builder.mutation({
                    query: ({
                        reflectionHtml,
                        reflectionDate,
                    }) => ({

                        url:
                        '/googleDriveTest/reflectionFormattedPublish',

                        method:
                        'POST',

                        body: {
                        reflectionHtml,
                        reflectionDate,
                        },

                    }),
            }),
      }),

  })

export const {

  useGetGoogleDocsConnectionStatusQuery,

  useLazyGetGoogleDocsConnectionStatusQuery,

  useLazyTestGoogleReflectionFolderQuery,

  useLazyTestGoogleReflectionDocumentQuery,

  useLazyTestGoogleReflectionTabQuery,

  // 27 Aug 2026

  useTestGoogleReflectionPublishMutation,
  
  useTestGoogleReflectionHtmlParseMutation,

  useTestGoogleReflectionFormattingModelMutation,

  useTestGoogleReflectionFormattingRequestsMutation,

  useTestGoogleReflectionFormattedPublishMutation,

  // 31 Aug 2026
  useDisconnectGoogleDocsMutation,

} =
  googleDocsAuthApiSlice